import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12.021 1.979C6.498 1.979 2.021 6.456 2.021 11.979C2.021 17.502 6.498 21.979 12.021 21.979C17.544 21.979 22.021 17.502 22.021 11.979C22.021 6.456 17.544 1.979 12.021 1.979V1.979ZM16.263 14.808C16.654 15.199 16.654 15.832 16.263 16.222C15.872 16.612 15.239 16.613 14.849 16.222L12.021 13.394L9.193 16.222C8.802 16.613 8.169 16.613 7.779 16.222C7.389 15.831 7.388 15.198 7.779 14.808L10.607 11.98L7.778 9.151C7.387 8.76 7.387 8.127 7.778 7.737C8.169 7.347 8.802 7.346 9.192 7.737L12.02 10.565L14.848 7.737C15.239 7.346 15.872 7.346 16.262 7.737C16.652 8.128 16.653 8.761 16.262 9.151L13.434 11.979L16.263 14.808Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'CrossFill');

export default Icon;
